<ngx-spinner 
  bdColor = "rgba(0, 0, 0, 0.8)" 
  size = "medium" 
  color = "#fff" 
  type = "line-spin-clockwise-fade" 
  [fullScreen] = "true"
>
  <p style="color: white" > {{ 'LOADING' | translate }}... </p>
</ngx-spinner>
<div class="mainContent">
  <div *ngIf="isLoading" class="spinner-container">
    <mat-progress-spinner mode="determinate" [value]="loadingPercentage" style="color: green;"></mat-progress-spinner>
    <p>{{ 'LOADING' | translate }}</p>
  </div>

  <mat-tab-group class="custom-tab-group" animationDuration="500ms" *ngIf="!isLoading">
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">account_box</mat-icon>
        {{ 'MAINPERSON' | translate }}
      </ng-template>
      <div class="tab-content">
        <form [formGroup]="mainForm" (ngSubmit)="onSubmit()">
          
          <h6>{{ 'GENERALINFORMATION' | translate }}</h6>
          <fieldset class="form-row">
            <div class="form-row">

              <div class="custom-field" style="width: 280px;">
                <label for="division_Id">{{ 'DIVISION' | translate }}<span style="color: red;">*</span></label>
                <mat-form-field>
                  <mat-select id="division_Id" formControlName="division_Id" placeholder="{{ 'SELECTOPTION' | translate }}" >
                    <mat-option *ngFor="let option of clientDivisions" [value]="option.id">
                      {{ option.clientdivisionname }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="mainForm.get('division_Id')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="form-row">
              <div class="custom-field">
                <label for="name">{{ 'NAME' | translate }}<span style="color: red;">*</span></label>
                <mat-form-field>
                  <input matInput id="name" formControlName="name" placeholder="{{ 'ENTERNAME' | translate }}" autocomplete="off" />
                  <mat-error *ngIf="mainForm.get('name')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
    
              <div class="custom-field">
                <label for="firstLastName">{{ 'FIRSTLASTNAME' | translate }}<span style="color: red;">*</span></label>
                <mat-form-field>
                  <input matInput id="firstLastName" formControlName="firstLastName" placeholder="{{ 'ENTERFIRSTLASTNAME' | translate }}" autocomplete="off" />
                  <mat-error *ngIf="mainForm.get('firstLastName')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
    
              <div class="custom-field">
                <label for="secondLastName">{{ 'SECONDLASTNAME' | translate }}</label>
                <mat-form-field>
                  <input matInput id="secondLastName" formControlName="secondLastName" placeholder="{{ 'ENTERSECONDLASTNAME' | translate }}" autocomplete="off" />
                  <mat-error *ngIf="mainForm.get('secondLastName')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="custom-field">
                <label for="maritalStatus_Id">{{ 'MARITALSTATUS' | translate }}<span style="color: red;">*</span></label>
                <mat-form-field>
                  <mat-select id="maritalStatus_Id" formControlName="maritalStatus_Id" placeholder="{{ 'SELECTOPTION' | translate }}" required>
                    <mat-option *ngFor="let option of maritalStatues" [value]="option.id">
                      {{ option.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="mainForm.get('maritalStatus_Id')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="custom-field">
                <label for="schooling_Id">{{ 'SCHOOLING' | translate }}<span style="color: red;"></span></label>
                <mat-form-field>
                  <mat-select id="schooling_Id" formControlName="schooling_Id" placeholder="{{ 'SELECTOPTION' | translate }}">
                    <mat-option *ngFor="let option of schoolings" [value]="option.id">
                      {{ option.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="mainForm.get('schooling_Id')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="custom-field">
                <label for="profession">{{ 'PROFESSION' | translate }}</label>
                <mat-form-field>
                  <input matInput id="profession" formControlName="profession" placeholder="{{ 'ENTERPROFESSION' | translate }}" autocomplete="off"  />
                  <mat-error *ngIf="mainForm.get('profession')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="custom-field">
                <label for="identityType_Id">{{ 'NATIONALIDENTITYTYPE' | translate }}<span style="color: red;">*</span></label>
                <mat-form-field>
                  <mat-select id="identityType_Id" formControlName="identityType_Id" placeholder="{{ 'SELECTOPTION' | translate }}" required >
                    <mat-option *ngFor="let option of iNT" [value]="option.id">
                      {{ option.identitynumbertypename }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="mainForm.get('identityType_Id')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="custom-field">
                <label for="nationalId">{{ 'NATIONALID' | translate }}<span style="color: red;">*</span></label>
                <mat-form-field>
                  <input matInput id="nationalId" formControlName="nationalId" placeholder="{{ 'ENTERNATIONALID' | translate }}" autocomplete="off" required/>
                  <mat-error *ngIf="mainForm.get('nationalId')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="custom-field" *ngIf="Service?.requiresTax">
                <label for="taxType_Id">{{ 'TAXNUMBERTYPE' | translate }}</label>
                <mat-form-field>
                  <mat-select id="taxType_Id" formControlName="taxType_Id" placeholder="{{ 'SELECTOPTION' | translate }}" >
                     <mat-option [value]="null">
                      {{ 'SELECTOPTION' | translate }}
                    </mat-option>
                    <mat-option *ngFor="let option of tNT" [value]="option.id">
                      {{ option.taxnumbertypename }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="mainForm.get('taxType_Id')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="custom-field" *ngIf="Service?.requiresTax">
                <label for="taxId">{{ 'TAXID' | translate }}</label>
                <mat-form-field>
                  <input matInput id="taxId" formControlName="taxId" placeholder="{{ 'ENTERTAXID' | translate }}" autocomplete="off"  />
                  <mat-error *ngIf="mainForm.get('taxId')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="custom-field" *ngIf="Service?.requiresSocial">
                <label for="socialType_Id">{{ 'SOCIALTYPEID' | translate }}</label>
                <mat-form-field>
                  <mat-select id="socialType_Id" formControlName="socialType_Id" placeholder="{{ 'SELECTOPTION' | translate }}" >
                    <mat-option [value]="null">
                      {{ 'SELECTOPTION' | translate }}
                    </mat-option>
                    <mat-option *ngFor="let option of sNT" [value]="option.id">
                      {{ option.socialnumbertypename }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="mainForm.get('socialType_Id')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="custom-field" *ngIf="Service?.requiresSocial">
                <label for="socialId">{{ 'SOCIALID' | translate }}</label>
                <mat-form-field>
                  <input matInput id="socialId" formControlName="socialId" placeholder="{{ 'ENTERSOCIALID' | translate }}" autocomplete="off"  />
                 <mat-error *ngIf="mainForm.get('socialId')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="custom-field" *ngIf="mainForm.get('identityType_Id')?.value !== 1">
                <label for="gender_Id">{{ 'GENDER' | translate }}<span style="color: red;">*</span></label>
                <mat-form-field>
                  <mat-select id="gender_Id" formControlName="gender_Id" placeholder="{{ 'SELECTOPTION' | translate }}" required >
                    <mat-option *ngFor="let option of genders" [value]="option.id">
                      {{ option.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="mainForm.get('gender_Id')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </fieldset>
    
            <h6>{{ 'ADDRESS' | translate }}</h6>
            <fieldset formGroupName="address" class="form-row">

              <div class="custom-field">
                <label for="country_Id">{{ 'COUNTRY' | translate }}</label>
                <mat-form-field>
                  <mat-label>{{ 'SELECTOPTION' | translate }}</mat-label>
                  <select matNativeControl id="country_Id" formControlName="country_Id" (change)="onCountryChange(getSelectValue($event))">
                    <option *ngFor="let option of countries" [value]="option.id">
                      {{ option.name }}
                    </option>
                  </select>
                  <mat-error *ngIf="mainForm.get('address.country_Id')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="custom-field">
                <label for="state_Id">{{ 'STATE' | translate }}<span style="color: red;">*</span></label>
                <mat-form-field>
                  <mat-label>{{ 'SELECTOPTION' | translate }}</mat-label>
                  <select matNativeControl id="state_Id" formControlName="state_Id" (change)="onStateChange(getSelectValue($event))">
                    <option *ngFor="let option of states" [value]="option.id">
                      {{ option.statename }}
                    </option>
                  </select>
                  <mat-error *ngIf="mainForm.get('address.state_Id')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="custom-field">
                <label for="city_Id">{{ 'CITY' | translate }}<span style="color: red;">*</span></label>
                <mat-form-field>
                  <mat-label>{{ 'SELECTOPTION' | translate }}</mat-label>
                  <select matNativeControl id="city_Id" formControlName="city_Id">
                    <option *ngFor="let option of localities" [value]="option.id">
                      {{ option.localityname }}
                    </option>
                  </select>
                  <mat-error *ngIf="mainForm.get('address.city_Id')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
    
              <div class="custom-field">
                <label for="street">{{ 'STREET' | translate }}<span style="color: red;">*</span></label>
                <mat-form-field>
                  <input matInput id="street" formControlName="street" placeholder="{{ 'ENTERSTREET' | translate }}" autocomplete="off" required />
                  <mat-error *ngIf="mainForm.get('address.street')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="custom-field">
                <label for="extNumber">{{ 'EXTNUMBER' | translate }}<span style="color: red;">*</span></label>
                <mat-form-field>
                  <input matInput id="extNumber" formControlName="extNumber" placeholder="{{ 'ENTEREXTNUMBER' | translate }}" autocomplete="off" required />
                  <mat-error *ngIf="mainForm.get('address.extNumber')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="custom-field">
                <label for="intNumber">{{ 'INTNUMBER' | translate }}</label>
                <mat-form-field>
                  <input matInput id="intNumber" formControlName="intNumber" placeholder="{{ 'ENTERINTNUMBER' | translate }}" autocomplete="off" />
                  <mat-error *ngIf="mainForm.get('address.intNumber')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="custom-field">
                <label for="sublocality">{{ 'COLOGNE' | translate }}<span style="color: red;">*</span></label>
                <mat-form-field>
                  <input matInput id="sublocality" formControlName="sublocality" placeholder="{{ 'ENTERSUBLOCALITY' | translate }}" autocomplete="off" required />
                  <mat-error *ngIf="mainForm.get('address.sublocality')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
    
              <div class="custom-field">
                <label for="postalCode">{{ 'POSTALCODE' | translate }}</label>
                <mat-form-field>
                  <input
                    matInput
                    type="number"
                    inputmode="numeric"
                    pattern="\d*"
                    id="postalCode"
                    formControlName="postalCode"
                    placeholder="{{ 'ENTERPOSTALCODE' | translate }}"
                    autocomplete="off"
                    (keydown)="onlyDigits($event)"
                  />
                  <mat-error *ngIf="mainForm.get('address.postalCode')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

            </fieldset>
    
            <!-- Birth Data -->
            <h6>{{ 'BIRTHDATA' | translate }}</h6>
            <fieldset formGroupName="birthData" class="form-row">

              <div class="custom-field">
                <label for="birthCountry_Id">{{ 'BIRTHCOUNTRY' | translate }}<span style="color: red;">*</span></label>
                <mat-form-field>
                  <mat-label>{{ 'SELECTOPTION' | translate }}</mat-label>
                  <select matNativeControl id="birthCountry_Id" formControlName="birthCountry_Id" (change)="onBirthCountryChange(getSelectValue($event))">
                    <option *ngFor="let option of birthCountries" [value]="option.id">
                      {{ option.name }}
                    </option>
                  </select>
                  <mat-error *ngIf="mainForm.get('birthData.birthCountry_Id')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="custom-field">
                <label for="birthState_Id">{{ 'BIRTHSTATE' | translate }}<span style="color: red;">*</span></label>
                <mat-form-field>
                  <mat-label>{{ 'SELECTOPTION' | translate }}</mat-label>
                  <select matNativeControl id="birthState_Id" formControlName="birthState_Id" (change)="onBirthStateChange(getSelectValue($event))">
                    <option *ngFor="let option of birthStates" [value]="option.id">
                      {{ option.statename }}
                    </option>
                  </select>
                  <mat-error *ngIf="mainForm.get('birthData.birthState_Id')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="custom-field">
                <label for="birthCity_Id">{{ 'BIRTHCITY' | translate }}<span style="color: red;">*</span></label>
                <mat-form-field>
                  <mat-label>{{ 'SELECTOPTION' | translate }}</mat-label>
                  <select matNativeControl id="birthCity_Id" formControlName="birthCity_Id">
                    <option *ngFor="let option of birthLocalities" [value]="option.id">
                      {{ option.localityname }}
                    </option>
                  </select>
                  <mat-error *ngIf="mainForm.get('birthData.birthCity_Id')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
    
              <div class="custom-field">
                <label for="birthDate">{{ 'BIRTHDATE' | translate }}<span style="color: red;">*</span></label>
                <mat-form-field>
                  <input matInput [matDatepicker]="birthDate" id="birthDate" formControlName="birthDate" placeholder="{{ 'ENTERBIRTHDATE' | translate }}" autocomplete="off" required />
                  <mat-hint>DD/MM/YYYY | DD-MM-YYYY</mat-hint>
                  <mat-datepicker-toggle matIconSuffix [for]="birthDate"></mat-datepicker-toggle>
                  <mat-datepicker #birthDate></mat-datepicker>
                  <mat-error *ngIf="mainForm.get('birthData.birthDate')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

            </fieldset>
    
            <div style="margin-bottom: 1rem;" *ngIf="Service?.serviceType_Id === 2 || (Service?.serviceType_Id === 1 && (mainForm.get('maritalStatus_Id')?.value === 1 || mainForm.get('maritalStatus_Id')?.value === 5 || mainForm.get('maritalStatus_Id')?.value === 6))">
              <h6>{{ 'RELATIVES' | translate }}</h6>
              <!-- Father -->
              <fieldset formGroupName="father" *ngIf="Service?.serviceType_Id === 2">
                <legend>{{ 'FATHER' | translate }}</legend>
                <mat-checkbox formControlName="isUnknown">{{ 'UNKNOWN' | translate }}</mat-checkbox>
                <div class="form-row">
                
                  <div class="custom-field">
                    <label for="fatherName">{{ 'NAME' | translate }}<span style="color: red;">*</span></label>
                    <mat-form-field>
                      <input matInput id="fatherName" formControlName="name" placeholder="{{ 'ENTERNAME' | translate }}" autocomplete="off" required />
                      <mat-error *ngIf="mainForm.get('father.name')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                
                  <div class="custom-field">
                    <label for="fFirstLastName">{{ 'FIRSTLASTNAME' | translate }}<span style="color: red;">*</span></label>
                    <mat-form-field>
                      <input matInput id="fFirstLastName" formControlName="firstLastName" placeholder="{{ 'ENTERFIRSTLASTNAME' | translate }}" autocomplete="off" required />
                      <mat-error *ngIf="mainForm.get('father.firstLastName')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                
                  <div class="custom-field">
                    <label for="fSecondLastName">{{ 'SECONDLASTNAME' | translate }}</label>
                    <mat-form-field>
                      <input matInput id="fSecondLastName" formControlName="secondLastName" placeholder="{{ 'ENTERSECONDLASTNAME' | translate }}" autocomplete="off" />
                      <mat-error *ngIf="mainForm.get('father.firstLastName')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                
                  <div class="custom-field">
                    <label for="fBirthDate">{{ 'BIRTHDATE' | translate }}<span style="color: red;">*</span></label>
                    <mat-form-field>
                      <input matInput [matDatepicker]="fBirthDate" id="fBirthDate" formControlName="birthDate" placeholder="{{ 'ENTERBIRTHDATE' | translate }}" required />
                      <mat-hint>DD/MM/YYYY</mat-hint>
                      <mat-datepicker-toggle matIconSuffix [for]="fBirthDate"></mat-datepicker-toggle>
                      <mat-datepicker #fBirthDate></mat-datepicker>
                      <mat-error *ngIf="mainForm.get('father.birthDate')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                
                  <div class="custom-field">
                    <label for="fOccupation_Id">{{ 'OCCUPATION' | translate }}<span style="color: red;">*</span></label>
                    <mat-form-field>
                      <mat-select id="fOccupation_Id" formControlName="occupation_Id" placeholder="{{ 'SELECTOPTION' | translate }}" required >
                        <mat-option *ngFor="let option of occupations" [value]="option.id">
                          {{ option.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="mainForm.get('father.occupation_Id')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="custom-field">
                    <label for="fcountry_Id">{{ 'COUNTRY' | translate }}</label>
                    <mat-form-field>
                      <mat-label>{{ 'SELECTOPTION' | translate }}</mat-label>
                      <select matNativeControl id="fcountry_Id" formControlName="country_Id" (change)="onfCountryChange(getSelectValue($event))">
                        <option *ngFor="let option of fCountries" [value]="option.id">
                          {{ option.name }}
                        </option>
                      </select>
                      <mat-error *ngIf="mainForm.get('father.country_Id')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="custom-field">
                    <label for="fstate_Id">{{ 'STATE' | translate }}<span style="color: red;">*</span></label>
                    <mat-form-field>
                      <mat-label>{{ 'SELECTOPTION' | translate }}</mat-label>
                      <select matNativeControl id="fstate_Id" formControlName="state_Id">
                        <option *ngFor="let option of fStates" [value]="option.id">
                          {{ option.statename }}
                        </option>
                      </select>
                      <mat-error *ngIf="mainForm.get('father.state_Id')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  
                </div>
              </fieldset>
            
              <!-- Mother -->
              <fieldset formGroupName="mother" *ngIf="Service?.serviceType_Id === 2">
                <legend>{{ 'MOTHER' | translate }}</legend>
                <mat-checkbox formControlName="isUnknown">{{ 'UNKNOWN' | translate }}</mat-checkbox>
                <div class="form-row">
                
                  <div class="custom-field">
                    <label for="motherName">{{ 'NAME' | translate }}<span style="color: red;">*</span></label>
                    <mat-form-field>
                      <input matInput id="motherName" formControlName="name" placeholder="{{ 'ENTERNAME' | translate }}" autocomplete="off" required />
                      <mat-error *ngIf="mainForm.get('mother.name')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                
                  <div class="custom-field">
                    <label for="mFirstLastName">{{ 'FIRSTLASTNAME' | translate }}<span style="color: red;">*</span></label>
                    <mat-form-field>
                      <input matInput id="mFirstLastName" formControlName="firstLastName" placeholder="{{ 'ENTERFIRSTLASTNAME' | translate }}" autocomplete="off" required />
                      <mat-error *ngIf="mainForm.get('mother.firstLastName')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                
                  <div class="custom-field">
                    <label for="mSecondLastName">{{ 'SECONDLASTNAME' | translate }}</label>
                    <mat-form-field>
                      <input matInput id="mSecondLastName" formControlName="secondLastName" placeholder="{{ 'ENTERSECONDLASTNAME' | translate }}" autocomplete="off" />
                      <mat-error *ngIf="mainForm.get('mother.firstLastName')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                
                  <div class="custom-field">
                    <label for="mBirthDate">{{ 'BIRTHDATE' | translate }}<span style="color: red;">*</span></label>
                    <mat-form-field>
                      <input matInput [matDatepicker]="mBirthDate" id="mBirthDate" formControlName="birthDate" placeholder="{{ 'ENTERBIRTHDATE' | translate }}" required />
                      <mat-hint>DD/MM/YYYY</mat-hint>
                      <mat-datepicker-toggle matIconSuffix [for]="mBirthDate"></mat-datepicker-toggle>
                      <mat-datepicker #mBirthDate></mat-datepicker>
                      <mat-error *ngIf="mainForm.get('mother.birthDate')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                
                  <div class="custom-field">
                    <label for="mOccupation_Id">{{ 'OCCUPATION' | translate }}<span style="color: red;">*</span></label>
                    <mat-form-field>
                      <mat-select id="mOccupation_Id" formControlName="occupation_Id" placeholder="{{ 'SELECTOPTION' | translate }}" required >
                        <mat-option *ngFor="let option of occupations" [value]="option.id">
                          {{ option.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="mainForm.get('mother.occupation_Id')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="custom-field">
                    <label for="mcountry_Id">{{ 'COUNTRY' | translate }}</label>
                    <mat-form-field>
                      <mat-label>{{ 'SELECTOPTION' | translate }}</mat-label>
                      <select matNativeControl id="mcountry_Id" formControlName="country_Id" (change)="onmCountryChange(getSelectValue($event))">
                        <option *ngFor="let option of mCountries" [value]="option.id">
                          {{ option.name }}
                        </option>
                      </select>
                      <mat-error *ngIf="mainForm.get('mother.country_Id')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="custom-field">
                    <label for="mstate_Id">{{ 'STATE' | translate }}<span style="color: red;">*</span></label>
                    <mat-form-field>
                      <mat-label>{{ 'SELECTOPTION' | translate }}</mat-label>
                      <select matNativeControl id="mstate_Id" formControlName="state_Id">
                        <option *ngFor="let option of mStates" [value]="option.id">
                          {{ option.statename }}
                        </option>
                      </select>
                      <mat-error *ngIf="mainForm.get('mother.state_Id')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                
                </div>
              </fieldset>
            
              <!-- Spouse -->
              <fieldset formGroupName="spouse" *ngIf="mainForm.get('maritalStatus_Id')?.value === 1 || mainForm.get('maritalStatus_Id')?.value === 5 || mainForm.get('maritalStatus_Id')?.value === 6" >
                <legend>{{ 'SPOUSE' | translate }}</legend>
                <div class="form-row">
                
                  <div class="custom-field">
                    <label for="spouseName">{{ 'NAME' | translate }}<span style="color: red;">*</span></label>
                    <mat-form-field>
                      <input matInput id="spouseName" formControlName="name" placeholder="{{ 'ENTERNAME' | translate }}" autocomplete="off" required />
                      <mat-error *ngIf="mainForm.get('spouse.name')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                
                  <div class="custom-field">
                    <label for="sFirstLastName">{{ 'FIRSTLASTNAME' | translate }}<span style="color: red;">*</span></label>
                    <mat-form-field>
                      <input matInput id="sFirstLastName" formControlName="firstLastName" placeholder="{{ 'ENTERFIRSTLASTNAME' | translate }}" autocomplete="off" required />
                      <mat-error *ngIf="mainForm.get('spouse.firstLastName')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                
                  <div class="custom-field">
                    <label for="sSecondLastName">{{ 'SECONDLASTNAME' | translate }}</label>
                    <mat-form-field>
                      <input matInput id="sSecondLastName" formControlName="secondLastName" placeholder="{{ 'ENTERSECONDLASTNAME' | translate }}" autocomplete="off" />
                      <mat-error *ngIf="mainForm.get('spouse.firstLastName')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                
                  <div class="custom-field">
                    <label for="sBirthDate">{{ 'BIRTHDATE' | translate }}<span style="color: red;">*</span></label>
                    <mat-form-field>
                      <input matInput [matDatepicker]="sBirthDate" id="sBirthDate" formControlName="birthDate" placeholder="{{ 'ENTERBIRTHDATE' | translate }}" required />
                      <mat-hint>DD/MM/YYYY</mat-hint>
                      <mat-datepicker-toggle matIconSuffix [for]="sBirthDate"></mat-datepicker-toggle>
                      <mat-datepicker #sBirthDate></mat-datepicker>
                      <mat-error *ngIf="mainForm.get('spouse.birthDate')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                
                  <div class="custom-field">
                    <label for="sOccupation_Id">{{ 'OCCUPATION' | translate }}<span style="color: red;">*</span></label>
                    <mat-form-field>
                      <mat-select id="sOccupation_Id" formControlName="occupation_Id" placeholder="{{ 'SELECTOPTION' | translate }}" required>
                        <mat-option *ngFor="let option of occupations" [value]="option.id">
                          {{ option.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="mainForm.get('spouse.occupation_Id')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="custom-field">
                    <label for="scountry_Id">{{ 'COUNTRY' | translate }}</label>
                    <mat-form-field>
                      <mat-label>{{ 'SELECTOPTION' | translate }}</mat-label>
                      <select matNativeControl id="scountry_Id" formControlName="country_Id" (change)="onsCountryChange(getSelectValue($event))">
                        <option *ngFor="let option of sCountries" [value]="option.id">
                          {{ option.name }}
                        </option>
                      </select>
                      <mat-error *ngIf="mainForm.get('spouse.country_Id')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="custom-field">
                    <label for="sstate_Id">{{ 'STATE' | translate }}<span style="color: red;">*</span></label>
                    <mat-form-field>
                      <mat-label>{{ 'SELECTOPTION' | translate }}</mat-label>
                      <select matNativeControl id="sstate_Id" formControlName="state_Id">
                        <option *ngFor="let option of sStates" [value]="option.id">
                          {{ option.statename }}
                        </option>
                      </select>
                      <mat-error *ngIf="mainForm.get('spouse.state_Id')?.hasError('required')">
                        {{ 'REQUIREDFIELD' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                
              </div>
            </fieldset>
          </div>

            <!-- Notes -->
            <h6>{{ 'COMMENTS' | translate }}</h6>
            <div class="form-row">
              <div class="notes-field">
                <mat-form-field>
                  <textarea matInput id="notes" formControlName="notes" placeholder="{{ 'ENTERCOMMENT' | translate }}" autocomplete="off"></textarea>
                  <mat-error *ngIf="mainForm.get('notes')?.hasError('required')">
                    {{ 'REQUIREDFIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
        </form>
      </div>
    </mat-tab>
    
    <mat-tab *ngIf="Service?.serviceType_Id === 2">
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">supervised_user_circle</mat-icon>
        {{ 'OTHERRELATIVES' | translate }}
      </ng-template>
      <div class="tab-content">
        
        <div class="table-container">
          <div class="actions-container">
            
            <button mat-raised-button color="primary" (click)="openAddRelativeDialog()" *ngIf="(Service?.status_Id != 3 && Service?.status_Id != 4) || (this.Service?.status_Id === 4  && this.Service?.scoreRisk === 40)">
              <mat-icon>add</mat-icon>
              {{ 'ADDRELATIVE' | translate }}
            </button>
        
            <mat-form-field appearance="fill" class="search-field">
              <mat-label>{{ 'SEARCHINTABLE' | translate }}</mat-label>
              <input matInput (keyup)="applyFilterRP($event)" placeholder='Find relative' />
            </mat-form-field>
          </div>
        
          <mat-table [dataSource]="relativesDataSource" matSort class="mat-elevation-z8">

            <ng-container matColumnDef="relative">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'RELATIVE' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.relativetypename }}</mat-cell>
            </ng-container>
            
            <ng-container matColumnDef="firstName">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'NAME' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.firstname }}</mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="firstLastName">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FIRSTLASTNAME' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.firstlastname }}</mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="secondLastName">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'SECONDLASTNAME' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.secondlastname }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="birthDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'BIRTHDATE' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.birthdate | date: 'dd/MM/yyyy' }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="occupationName">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'OCCUPATION' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.occupationname }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="stateName">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'STATE' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.statename }}</mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef>{{ 'ACTIONS' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <button mat-icon-button style="color: rgb(172, 174, 174);" (click)="editRelative(element)" *ngIf="(Service?.status_Id != 3 && Service?.status_Id != 4) || (this.Service?.status_Id === 4  && this.Service?.scoreRisk === 40)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button style="color: #B12D2C;" (click)="confirmDeleteRelative(element)" *ngIf="(Service?.status_Id != 3 && Service?.status_Id != 4) || (this.Service?.status_Id === 4  && this.Service?.scoreRisk === 40)">
                  <mat-icon>delete</mat-icon>
                </button>
              </mat-cell>
            </ng-container>
        
            <mat-header-row *matHeaderRowDef="relativesDisplayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: relativesDisplayedColumns;"></mat-row>
          </mat-table>
        
          <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
        </div>
      </div>
    </mat-tab>

    <mat-tab *ngIf="Service?.serviceType_Id === 2">
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">work</mat-icon>
        {{ 'JOBS' | translate }}
      </ng-template>
      <div class="tab-content">
        
        <div class="table-container">
          <div class="actions-container">
            
            <button mat-raised-button color="primary" (click)="openAddEHDialog()" *ngIf="(Service?.status_Id != 3 && Service?.status_Id != 4) || (this.Service?.status_Id === 4  && this.Service?.scoreRisk === 40)">
              <mat-icon>add</mat-icon>
              {{ 'ADDJOB' | translate }}
            </button>
        
            <mat-form-field appearance="fill" class="search-field">
              <mat-label>{{ 'SEARCHINTABLE' | translate }}</mat-label>
              <input matInput (keyup)="applyFilterEH($event)" placeholder='Find relative' />
            </mat-form-field>
          </div>
        
          <mat-table [dataSource]="employmentHistoryDataSource" matSort class="mat-elevation-z8">
            
            <ng-container matColumnDef="company">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'COMPANY' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.company }}</mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="position">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'POSITION' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.position }}</mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="startDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'STARTDATE' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.startdate | date: 'dd/MM/yyyy' }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="endDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ENDDATE' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.enddate ? (element.enddate | date: 'dd/MM/yyyy') : '-' }}</mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef>{{ 'ACTIONS' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <button mat-icon-button style="color: rgb(172, 174, 174);" (click)="editEH(element)" *ngIf="(Service?.status_Id != 3 && Service?.status_Id != 4) || (this.Service?.status_Id === 4  && this.Service?.scoreRisk === 40)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button style="color: #B12D2C;" (click)="confirmDeleteEH(element)" *ngIf="(Service?.status_Id != 3 && Service?.status_Id != 4) || (this.Service?.status_Id === 4  && this.Service?.scoreRisk === 40)">
                  <mat-icon>delete</mat-icon>
                </button>
              </mat-cell>
            </ng-container>
        
            <mat-header-row *matHeaderRowDef="employmentHistoryDisplayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: employmentHistoryDisplayedColumns;"></mat-row>
          </mat-table>
        
          <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
        </div>
      </div>
    </mat-tab>

    <mat-tab *ngIf="Service?.serviceType_Id === 2">
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">class</mat-icon>
        {{ 'REFERENCES' | translate }}
      </ng-template>
      <div class="tab-content">
        
        <div class="table-container">
          <div class="actions-container">
            
            <button mat-raised-button color="primary" (click)="openAddprpDialog()" *ngIf="(Service?.status_Id != 3 && Service?.status_Id != 4) || (this.Service?.status_Id === 4  && this.Service?.scoreRisk === 40)">
              <mat-icon>add</mat-icon>
              {{ 'ADDREFERENCE' | translate }}
            </button>
        
            <mat-form-field appearance="fill" class="search-field">
              <mat-label>{{ 'SEARCHINTABLE' | translate }}</mat-label>
              <input matInput (keyup)="applyFilterEH($event)" placeholder='Find relative' />
            </mat-form-field>
          </div>
        
          <mat-table [dataSource]="prpDataSource" matSort class="mat-elevation-z8">
            
            <ng-container matColumnDef="firstName">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'NAME' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.firstname }}</mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="firstLastName">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FIRSTLASTNAME' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.firstlastname }}</mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="secondLastName">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'SECONDLASTNAME' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.secondlastname }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="age">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'AGE' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.age }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="occupation">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'OCCUPATION' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.occupationname }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="statename">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'STATE' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.statename }}</mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef>{{ 'ACTIONS' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <button mat-icon-button style="color: rgb(172, 174, 174);" (click)="editprp(element)" *ngIf="(Service?.status_Id != 3 && Service?.status_Id != 4) || (this.Service?.status_Id === 4  && this.Service?.scoreRisk === 40)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button style="color: #B12D2C;" (click)="confirmDeleteEH(element)" *ngIf="(Service?.status_Id != 3 && Service?.status_Id != 4) || (this.Service?.status_Id === 4  && this.Service?.scoreRisk === 40)">
                  <mat-icon>delete</mat-icon>
                </button>
              </mat-cell>
            </ng-container>
        
            <mat-header-row *matHeaderRowDef="prpDisplayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: prpDisplayedColumns;"></mat-row>
          </mat-table>
        
          <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
        </div>
      </div>
    </mat-tab>
    
  </mat-tab-group>
  <div class="floating-buttons">
    <div class="progress-container">
      <mat-progress-bar mode="determinate" [value]="Service?.requestProgress" style="width: 100%;"></mat-progress-bar>
      <span>{{ Service?.requestProgress }}%</span>
    </div>
  
    <button
      mat-raised-button
      class="send-button"
      (click)="sendToSIES()"
      *ngIf="Service?.requestProgress === 100 && (Service?.status_Id != 3 && Service?.status_Id != 4)"
    >
      {{ 'SEND' | translate }}
    </button>

    <button
      mat-raised-button
      class="send-button"
      (click)="resendToSIES()"
      *ngIf="Service?.requestProgress === 100 && (Service?.status_Id === 4 && Service?.scoreRisk === 40 && Service?.updateOverResult)"
    >
      {{ 'RESUBMIT' | translate }}
    </button>
  
    <div class="buttons-group">
      <button mat-raised-button class="back-button" (click)="backToDashboard()">
        {{ 'BACK' | translate }}
      </button>
      
      <button mat-raised-button class="save-button" (click)="onSubmit()" *ngIf="Service?.status_Id != 3 && !(Service?.status_Id === 4) && !(Service?.status_Id === 4 && Service?.scoreRisk === 40)">
        {{ 'SAVE' | translate }}
      </button>

      <button mat-icon-button style="color:#B12D2C;" (click)="highlightMissing()" matTooltip="{{ 'FOCUSREQUIREDFIELDS' | translate }}">
        <mat-icon>report_problem</mat-icon>
      </button>
    </div>
  </div>    
</div>